module.exports = __webpack_public_path__ + "img/banner_image4.06de0391.jpg";